module.exports = __webpack_public_path__ + "media/images/athletes/3527-65a43e2d39ec14ce2284633cb5d07534.png";